import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';

import {TranslateModule} from '@ngx-translate/core';
import {LoggerService} from './logger/logger.service';
import {AuthDirective} from '../auth/auth.directive';
import {WindowRefService} from './window.service';
import {WebsocketService} from './websocket/websocket.service';
import {StatusListenerService} from './status/status-listener.service';
import {SearchService} from './search.service';
import {AppMessageService} from './app-message/app-message.service';
import {PushNotificationsService} from './app-message/push-notifications.service';
import {SidebarService} from './sidebar/sidebar.service';
import {LinkyModule} from 'angular-linky';
import {SessionStorageService} from 'angular-web-storage';
import {QmPipesModule} from '../components/qm-pipes/qm-pipes.module';
import {LoadingModule} from '../components/loading/loading.module';
import {QmDirectivesModule} from '../components/qm-directives/qm-directives.module';
import {AppStabilityService} from './app-stability.service';
import { CacheService } from './cache.service';

/**
 * Global module, contains basic modules and services that all other modules require.
 * Do not specify providers for modules that might be imported by a lazy loaded module.
 */
@NgModule({
  declarations: [AuthDirective],
  imports: [CommonModule],
  exports: [TranslateModule, CommonModule, FormsModule, AuthDirective,
    LinkyModule, QmPipesModule, LoadingModule, QmDirectivesModule],
  providers: [LoggerService, WindowRefService, WebsocketService, StatusListenerService, CacheService,
    SearchService, AppMessageService, PushNotificationsService, SidebarService, SessionStorageService, AppStabilityService]
})
export class SharedProviderModule {
}
